<template>
  <div class="container-fluid">
    <loading
          :active.sync="isLoading" 
          :can-cancel="true" 
          :is-full-page="true"
          color="#007bff"
          background-color="#ffffff"
      >
      </loading>
    <div class="m-2">
      <div class="alert alert-primary h4 text-center">
          <linkto :link="'/'"/>
          Ügyfél keresés
      </div>
    </div>
    <div class="m-1">
        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select v-model="searchobj.aktiv">
                        <option :value="0">NEM Aktív</option>
                        <option :value="1">Aktív</option>
                        <option :value="2">Mindkettő</option>
                    </select>
                    <label>Ügyfél státusz</label>
                </div>
            </div>
            <div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select v-model="searchobj.kat">
                        <option v-for="(k,index) in kat" :key="index" :value="k.kszam">{{k.nev}}</option>
                    </select>
                    <label>Kategória</label>
                </div>
            </div>
            <div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select v-model="searchobj.tip">
                        <option v-for="(k,index) in tip" :key="index" :value="k.kszam">{{k.nev}}</option>
                    </select>
                    <label>Típus</label>
                </div>
            </div>
            
            <!--<div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select class="form-control" v-model="searchobj.szolg">
                        <option
                            v-for="(item,index) in szolg"
                            :key="`sz-${index}`"
                            :value="item.id"
                        >    
                            {{item.nev}}
                        </option>
                    </select>
                    <label>Számla-kiállító</label>
                </div>
            </div>-->

            <div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select v-model="searchobj.szla_tipus">
                        <option
                            v-for="(item,index) in szla_tipusok_search"
                            :key="`szla-${index}`"
                            :value="item.id"
                        >
                            {{item.nev}}
                        </option>
                    </select>
                    <label>Fizetési mód</label>
                </div>
                <!--<div class="mui-select m-2">
                    <select class="form-control" v-model="searchobj.szolg">
                        <option
                            v-for="(item,index) in szolg"
                            :key="`sz-${index}`"
                            :value="item.id"
                        >    
                            {{item.nev}}
                        </option>
                    </select>
                    <label>Számla-kiállító</label>
                </div>-->
            </div>

            <div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select v-model="searchobj.automataa">
                        <option :value="0">Nincs</option>
                        <option :value="1">Van</option>
                        <option :value="2">Mindkettő</option>
                    </select>
                    <label>Automata</label>
                </div>
            </div>
            <div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select v-model="searchobj.automata_szerzodes">
                        <option :value="0">Nincs</option>
                        <option :value="1">Van</option>
                        <option :value="2">Mindkettő</option>
                    </select>
                    <label>Automata szerződés</label>
                </div>
            </div>
            <div class="col-6 col-lg-3">
              <div class="text-center">Régiókód intervallumra szűkítés</div>
              <div class="input-group m-2">
                  <input type="text" class="text-center form-control" v-model="searchobj.regio_tol">
                  <input type="text" class="text-center form-control" v-model="searchobj.regio_ig">
              </div>
            </div>
            <div class="col-6 col-lg-3">
              <div class="text-center">Limit intervallumra szűkítés</div>
              <div class="input-group m-2">
                  <input type="number" class="text-center form-control" v-model="searchobj.min_tol">
                  <input type="number" class="text-center form-control" v-model="searchobj.min_ig">
              </div>
            </div>
            <div class="col-6 col-lg-2">
                <div class="mui-select m-2">
                    <select v-model="searchobj.sendVoiceMail">
                        <option :value="2">Mindkettő</option>
                        <option :value="0">Nem</option>
                        <option :value="1">Igen</option>
                    </select>
                    <label>Hangüzenet-kiküldése</label>
                </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.nev">
                    <label>Név (elég a szótöredék pl: `Ková` vagy `éter`)</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.iszam">
                    <label>Irányítószám</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.varos">
                    <label>Város (elég a szótöredék pl: `szege` vagy `háza`)</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.cim">
                    <label>Cím (régi egyben írt, pl: Kossuth utca 28.)</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.cim_utca">
                    <label>Közterület típusa, pl utca tér</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-2">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.tel">
                    <label>Telefon</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-2">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.cim_hsz">
                    <label>Házszám</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-2">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.cim_ea">
                    <label>Emelet / ajtó</label>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-2">
                <div class="mui-textfield m-1">
                    <input type="text" v-model="searchobj.megj">
                    <label>Megjegyzés</label>
                </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-12 text-center">
                <button class="btn btn-lg btn-outline-danger" @click.prevent="defaultsearch()">Keresési feltételek alapértelmezése</button>
                <button class="btn btn-lg btn-primary m-2" @click.prevent="load">Keresés</button>
                <button class="btn btn-lg btn-outline-success" disabled>
                    {{customers_length}} ügyfél
                </button>
            </div>
            <div class="col-12 mt-2 mb-2 text-center">
              <span class="font-weight-bold h4 text-danger">
                Piros háttérrel kiemelve a INAKTÍV ügyfelek!!
              </span>
            </div>
        </div>
    </div>
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-light">
                <th>Telefon</th>
            </thead>
            <tbody>
                <tr>
                    <td><input type="checkbox" v-model="show.telefon"/></td>    
                </tr>
            </tbody>
        </table>
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>
                <input type="checkbox" v-model="check" @change="check_list">
            </th>
            <th scope="col">#</th>
            <th scope="col">
                <a href="" class="hover" @click.prevent="order=`regio`">Régió</a>
                <i v-show="order===`regio`" class="fas fa-lg fa-sort float-right text-danger" @click.prevent="order_dir = !order_dir"></i>
            </th>
            <!--<th scope="col">#</th>-->
            <th scope="col">#</th>
            <th scope="col">
                <a href="" class="hover" @click.prevent="order=`nev`">Név</a>
                <i v-show="order===`nev`" class="fas fa-lg fa-sort float-right text-danger" @click.prevent="order_dir = !order_dir"></i>
            </th>
            <th v-show="show.telefon">Telefon</th>
            <th scope="col">Ir</th>
            <th scope="col">Város</th>
            <th scope="col">
                <a href="" class="hover" @click.prevent="order=`cim`">Cím</a>
                <i v-show="order===`cim`" class="fas fa-lg fa-sort float-right text-danger" @click.prevent="order_dir = !order_dir"></i>
            </th>
            <!--<th scope="col">
                <a href="" class="hover" @click.prevent="order=`szolgaltato`">Szolgáltató</a>
                <i v-show="order===`szolgaltato`" class="fas fa-lg fa-sort float-right text-danger" @click.prevent="order_dir = !order_dir"></i>
            </th>-->
            <th scope="col">
                <a href="" class="hover" @click.prevent="order=`min`">Rendelési limit</a>
                <i v-show="order===`min`" class="fas fa-lg fa-sort float-right text-danger" @click.prevent="order_dir = !order_dir"></i>
            </th>
            <th scope="col">Módosít</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in customers"
            :key="index"
            :class="[item.aktiv == 0 ? 'table-danger' : '']"
          >
            <td>
              <input type="checkbox" v-model="item.check" :id="`c-${index}`">
            </td>
            <td>{{item.id}}</td>
            <td>{{item.regio}}</td>
            <!--<td>
              <button class="btn btn-outline-primary" @click.prevent="new_order(item)">
                Új rendelés
              </button>
            </td>-->
            <td>
              <order-history
                :id="item.id"
              >
              </order-history>
            </td>
            <td v-tooltip="tooltip(item)">{{item.nev}}</td>
            <td v-show="show.telefon">
                {{item.telm | tel}}
                <br v-if="item.telv != ''">
                {{item.telv | tel}}
            </td>
            <td>{{item.iszam}}</td>
            <td>{{item.varos}}</td>
            <td>{{item.cim}}</td>
            <!--<td>{{item.szolgnev}}</td>-->
            <td>{{item.min}} Ft</td>
            <td>
              <router-link
                :to="`/customer/${item.id}`" target="_blank"
              >
                  <button class="btn btn-outline-primary">
                      Módosít
                  </button>
              </router-link>
              <!--<button class="btn btn-outline-primary" @click.prevent="change_customer(item.id)">
                  Módosít
              </button>-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pb-5" v-show="checked_customers.length > 0">
        <div class="alert alert-primary">
            <div class="h5 text-center">
                Csoportos műveletek a kijelölt ügyfeleken - {{checked_customers.length}} ügyfél
            </div>
        </div>
        <div class="m-2">
            <div class="row d-flex justify-content-center">
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="input-group m-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Régiókód váltás erre:</span>
                        </div>
                        <input type="number" class="form-control" v-model="cs_regio">
                        <div class="input-group-append">
                            <button
                                class="btn btn-primary"
                                :disabled="cs_regio < 1"
                                @click.prevent="cs_change('regio',cs_regio)"
                            >
                                Módosít
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="input-group m-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Szolgáltató váltás erre:</span>
                        </div>
                        <select class="form-control" v-model="cs_szolg">
                            <option
                                v-for="(item,index) in szolg"
                                :key="`sz-${index}`"
                                :value="item.id"
                            >    
                                {{item.nev}}
                            </option>
                        </select>
                        <div class="input-group-append">
                            <button
                                class="btn btn-primary"
                                :disabled="cs_szolg < 1"
                                @click.prevent="cs_change('szolgaltato',cs_szolg)"
                            >
                                Módosít
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="input-group m-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Típus váltás erre:</span>
                        </div>
                        <select class="form-control" v-model="cs_tip">
                            <option
                                v-for="(item,index) in tip"
                                :key="`t-${index}`"
                                :value="item.id"
                            >                   
                                {{item.nev}}       
                            </option>
                        </select>
                        <div class="input-group-append">
                            <button
                                class="btn btn-primary"
                                :disabled="cs_tip <= 0"
                                @click.prevent="cs_change('tipus_id',cs_tip)"
                            >
                                Módosít
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="input-group m-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Ciklusidő váltás erre:</span>
                        </div>
                        <input type="number" class="form-control" v-model="cs_datum">
                        <div class="input-group-append">
                            <button
                                class="btn btn-primary"
                                :disabled="cs_datum <= 0"
                                @click.prevent="cs_change('datum_limit',cs_datum)"
                            >
                                Módosít
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="input-group m-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Minimum összeg váltás erre:</span>
                        </div>
                        <input type="number" class="form-control" v-model="cs_min">
                        <div class="input-group-append">
                            <button
                                class="btn btn-primary"
                                :disabled="cs_min <= 0"
                                @click.prevent="cs_change('min',cs_min)"
                            >
                                Módosít
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="input-group m-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Hangüzenet-kiküldés váltás erre:</span>
                        </div>
                        <select class="form-control" v-model="cs_hang">
                            <option value="0">
                                Nem
                            </option>
                            <option value="1">
                                Igen
                            </option>
                        </select>
                        <div class="input-group-append">
                            <button
                                class="btn btn-primary"
                                @click.prevent="cs_change('sendVoiceMail',cs_hang)"
                            >
                                Módosít
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="pb-5" v-show="checked_customers.length === 0">
        <div class="alert alert-warning">
            <div class="h5 text-center">
                Nincs kijelölve ügyfél csoportos műveletre
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import Vue from 'vue'
export default {
  name: 'customers',
  data () {
      return {
          customers: [],
          searchobj: {
              aktiv: 2,
              kat: 0,
              tip: 0,
              szolg: 0,
              id: '',
              min_tol: 0,
              min_ig: 1000000,
              regio_tol: 0,
              regio_ig: 9999,
              nev: '',
              varos: '',
              automataa: 2,
              automata_szerzodes: 2,
              cim: '',
              cim_utca: '',
              cim_hsz: '',
              cim_ea: '',
              tel: '',
              iszam: '',
              megj: '',
              sendVoiceMail: 2,
              szla_tipus: 0
          },
          kat: [],
          tip: [],
          szolg: [],
          cs_regio: 0,
          cs_szolg: 0,
          cs_tip: 0,
          cs_datum: 0,
          cs_min: 0,
          cs_hang: 0,
          order: 'nev',
          order_dir: false,
          check: false,
          show: {
            telefon: false
          }
      }
  },
  mounted(){
      this.$Progress.start()
      this.isLoading = true
      this.defaultsearch()
      this.req.post(`/others`)
          .then(res => {
              this.kat = res.data.kat
              this.kat.splice(0,0,{ "id": 0, "kszam": 0, "nev": "Minden kategória", "megjegyzes": null })
              this.tip = res.data.tip
              this.tip.splice(0,0,{ "id": 0, "kszam": 0, "nev": "Minden típus", "megjegyzes": null })
              this.szolg = res.data.szolg
              this.szolg.splice(0,0,{ "id": 0, "nev": "Minden kiállító", "megjegyzes": null })
              this.$Progress.finish()
              this.isLoading = false
          })
          .catch(err => {
              console.log(err)
              this.$Progress.fail()
              this.isLoading = false
          })
  },
  methods: {
      ...mapActions(['setcustomerssearch','setrendselcustomer']),
      defaultsearch(){
          this.searchobj = {
              aktiv: 2,
              kat: 0,
              tip: 0,
              szolg: 0,
              id: '',
              min_tol: 0,
              min_ig: 1000000,
              regio_tol: 0,
              regio_ig: 9999,
              nev: '',
              varos: '',
              automataa: 2,
              automata_szerzodes: 2,
              cim: '',
              cim_utca: '',
              cim_hsz: '',
              cim_ea: '',
              iszam: '',
              megj: '',
              sendVoiceMail: 2,
              szla_tipus: 0
          }
          this.customers = []
      },
      
      load(){
          this.$Progress.start()
          this.isLoading = true
          this.req.post('/customers/search', {
              search: this.searchobj,
              order: this.order,
              order_dir: this.order_dir
          })
              .then(res => {
                  this.customers = res.data.customers
                  this.$Progress.finish()
                  this.isLoading = false
              })
              .catch(err => {
                console.log(err)
                this.$Progress.fail()
                this.isLoading = false
              })
      },

      new_order(item){
          this.setrendselcustomer(item)
          window.open(this.$router.resolve({ path: '/orders/new_order/products' }).href, '_blank')
      },
      
      cs_change(mit,mire){
          this.$Progress.start()
          this.req.post('/customers/change',{
              array: this.checked_customers,
              change: mit,
              value: ~~mire
          })
              .then(res=>{
                  if(res.data.status == 'ok'){
                      toastr.success('Változtatás sikeres')
                      this.check = false
                      this.check_list()
                      this.load()
                      this.$Progress.finish()
                  } else {
                      toastr.error('Változtatás sikertelen')
                      this.$Progress.fail()
                  }
              })
              .catch(err=>{
                  console.log(err)
                  this.$Progress.fail()
              })
      },

      check_list(){
          for (var i in this.customers) {
              this.customers[i].check = this.check
          }
      },

      tooltip(x) {
          let v = Vue.filter('tel')(x.telv)
          let m = Vue.filter('tel')(x.telm)
          let tel =  `${v}${v&&m?' <br> ':''}${m} <br><br>`

          let email = x.email
          if(x.email.length > 0 && x.email) email = email + '<br><br>'

          return `${tel}${email}${x.megj!=null?x.megj:''}`
      }
  },
  computed: {
      checked_customers(){
          return this.customers !== null ? this.customers.filter(x=>x.check).map(el=>el.id) : []
      },
      customers_length(){
          return this.customers !== null ? this.customers.length : 0
      }
  },
  watch: {
      order(){
          this.load()
      },
      order_dir(){
          this.load()
      }
  }
}
</script>

<style scoped>
i {
  cursor: pointer;
}

.hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/customers/customer_search.vue